import { z } from "zod";
import { salesChannelSchema } from "./sales-channel";

export const getRedoSalesChannels = {
  input: z.object({}),
  output: z.object({
    redoSalesChannels: z.array(salesChannelSchema).nullable(),
  }),
};
